import { CustomMonitor } from '@jdd/sgm-monitor';

export default CustomMonitor;
